/**
 * Escrituras de la lección priest-1 (presbítero). Texto de churchofjesuschrist.org / DyC 20 alineado con scriptures.training.core3.
 */
import type { Scripture } from './scriptures';

export const priest1TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-20-46-52',
    reference: 'Doctrina y Convenios 20:46–52',
    text:
      'El deber del presbítero es predicar, enseñar, exponer, exhortar, bautizar y administrar la santa cena, y visitar la casa de todos los miembros, y exhortarlos a orar vocalmente, así como en secreto, y a cumplir con todos los deberes familiares. Y también puede ordenar a otros presbíteros, maestros y diáconos. Y ha de hacerse cargo de las reuniones cuando no esté presente ningún élder; mas cuando esté presente un élder, solamente ha de predicar, enseñar, exponer, exhortar y bautizar; y visitar la casa de todos los miembros, exhortándolos a orar vocalmente, así como en secreto, y a cumplir con todos los deberes familiares. En todos estos deberes, el presbítero debe ayudar al élder, si la ocasión lo requiere.',
    verses: [
      {
        verse: 46,
        text: 'El deber del presbítero es predicar, enseñar, exponer, exhortar, bautizar y administrar la santa cena,',
      },
      {
        verse: 47,
        text: 'y visitar la casa de todos los miembros, y exhortarlos a orar vocalmente, así como en secreto, y a cumplir con todos los deberes familiares.',
      },
      {
        verse: 48,
        text: 'Y también puede ordenar a otros presbíteros, maestros y diáconos.',
      },
      {
        verse: 49,
        text: 'Y ha de hacerse cargo de las reuniones cuando no esté presente ningún élder;',
      },
      {
        verse: 50,
        text: 'mas cuando esté presente un élder, solamente ha de predicar, enseñar, exponer, exhortar y bautizar;',
      },
      {
        verse: 51,
        text: 'y visitar la casa de todos los miembros, exhortándolos a orar vocalmente, así como en secreto, y a cumplir con todos los deberes familiares.',
      },
      {
        verse: 52,
        text: 'En todos estos deberes, el presbítero debe ayudar al élder, si la ocasión lo requiere.',
      },
    ],
    context: 'Deberes del presbítero: enseñar, Santa Cena, visitas y apoyo al élder.',
  },
  {
    id: '3-nephi-18-1-7',
    reference: '3 Nefi 18:1–7',
    text:
      'Y aconteció que Jesús mandó a sus discípulos que le llevasen pan y vino. Y mientras fueron a traer el pan y el vino, mandó a la multitud que se sentara en el suelo. Y cuando los discípulos hubieron llegado con pan y vino, tomó el pan y lo partió y lo bendijo; y dio a los discípulos y les mandó que comiesen. Y cuando hubieron comido y fueron llenos, mandó que dieran a la multitud. Y cuando la multitud comió y fue llena, dijo a los discípulos: He aquí, uno de vosotros será ordenado; y a él le daré poder para partir pan y bendecirlo y darlo a los de mi iglesia, a todos los que crean y se bauticen en mi nombre. Y siempre procuraréis hacer esto, tal como yo lo he hecho, así como he partido pan y lo he bendecido y os lo he dado. Y haréis esto en memoria de mi cuerpo que os he mostrado. Y será un testimonio al Padre de que siempre os acordáis de mí. Y si os acordáis siempre de mí, tendréis mi Espíritu para que esté con vosotros.',
    verses: [
      {
        verse: 1,
        text: 'Y aconteció que Jesús mandó a sus discípulos que le llevasen pan y vino.',
      },
      {
        verse: 2,
        text: 'Y mientras fueron a traer el pan y el vino, mandó a la multitud que se sentara en el suelo.',
      },
      {
        verse: 3,
        text: 'Y cuando los discípulos hubieron llegado con pan y vino, tomó el pan y lo partió y lo bendijo; y dio a los discípulos y les mandó que comiesen.',
      },
      {
        verse: 4,
        text: 'Y cuando hubieron comido y fueron llenos, mandó que dieran a la multitud.',
      },
      {
        verse: 5,
        text: 'Y cuando la multitud comió y fue llena, dijo a los discípulos: He aquí, uno de vosotros será ordenado; y a él le daré poder para partir pan y bendecirlo y darlo a los de mi iglesia, a todos los que crean y se bauticen en mi nombre.',
      },
      {
        verse: 6,
        text: 'Y siempre procuraréis hacer esto, tal como yo lo he hecho, así como he partido pan y lo he bendecido y os lo he dado.',
      },
      {
        verse: 7,
        text: 'Y haréis esto en memoria de mi cuerpo que os he mostrado. Y será un testimonio al Padre de que siempre os acordáis de mí. Y si os acordáis siempre de mí, tendréis mi Espíritu para que esté con vosotros.',
      },
    ],
    context: 'Institución de la Santa Cena entre los nefitas: pan, vino y memoria del Salvador.',
  },
  {
    id: 'dc-84-33-39',
    reference: 'Doctrina y Convenios 84:33–39',
    text:
      'Porque quienes son fieles hasta obtener estos dos sacerdocios de los cuales he hablado, y magnifican su llamamiento, son santificados por el Espíritu para la renovación de sus cuerpos. Llegan a ser los hijos de Moisés y de Aarón, y la descendencia de Abraham, y la iglesia y reino, y los elegidos de Dios. Y también todos los que reciben este sacerdocio, a mí me reciben, dice el Señor; porque el que recibe a mis siervos, me recibe a mí; y el que me recibe a mí, recibe a mi Padre; y el que recibe a mi Padre, recibe el reino de mi Padre; por tanto, todo lo que mi Padre tiene le será dado. Y esto va de acuerdo con el juramento y el convenio que corresponden a este sacerdocio.',
    verses: [
      {
        verse: 33,
        text: 'Porque quienes son fieles hasta obtener estos dos sacerdocios de los cuales he hablado, y magnifican su llamamiento, son santificados por el Espíritu para la renovación de sus cuerpos.',
      },
      {
        verse: 34,
        text: 'Llegan a ser los hijos de Moisés y de Aarón, y la descendencia de Abraham, y la iglesia y reino, y los elegidos de Dios.',
      },
      {
        verse: 35,
        text: 'Y también todos los que reciben este sacerdocio, a mí me reciben, dice el Señor;',
      },
      {
        verse: 36,
        text: 'porque el que recibe a mis siervos, me recibe a mí;',
      },
      {
        verse: 37,
        text: 'y el que me recibe a mí, recibe a mi Padre;',
      },
      {
        verse: 38,
        text: 'y el que recibe a mi Padre, recibe el reino de mi Padre; por tanto, todo lo que mi Padre tiene le será dado.',
      },
      {
        verse: 39,
        text: 'Y esto va de acuerdo con el juramento y el convenio que corresponden a este sacerdocio.',
      },
    ],
    context: 'Sacerdocio, santificación y convenio: recibir al Señor y al Padre.',
  },
];
